"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORIZATION_CODE_QUERY_PARAM = void 0;
exports.AUTHORIZATION_CODE_QUERY_PARAM = 'authorizationCode';
//# sourceMappingURL=types.js.map